export const curriculumTabNames = ["write", "read"] as const;
export type CurriculumTabName = typeof curriculumTabNames[number];

export function isCurriculumTabName(str: string): str is CurriculumTabName {
  return curriculumTabNames.some(v => v === str);
}
